import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../api";
import { AuthShell } from "./Login";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking"); // checking | ok | error
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <AuthShell
      title="Email verification"
      subtitle=""
      footer={<><Link to="/credit/app" className="text-blue-300 hover:text-blue-200">Go to dashboard</Link></>}
    >
      <div className="text-center py-2">
        {state === "checking" && (
          <div data-testid="verify-checking"><Loader2 size={38} className="mx-auto animate-spin text-blue-400" /><p className="text-slate-400 text-sm mt-4">Verifying your email…</p></div>
        )}
        {state === "ok" && (
          <div data-testid="verify-ok"><CheckCircle2 size={44} className="mx-auto text-emerald-400" /><p className="text-white text-sm mt-4">Your email is verified. Thank you!</p></div>
        )}
        {state === "error" && (
          <div data-testid="verify-error"><XCircle size={44} className="mx-auto text-amber-400" /><p className="text-slate-300 text-sm mt-4">This verification link is invalid or has expired. You can request a new one from Settings.</p></div>
        )}
      </div>
    </AuthShell>
  );
}
